import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { ETypeDomain } from "../../../../config/types";
import { RelatorioMensalVendaModel } from "../../../../views/pages/private/relatorios/models/relatorio-models";
import { useApiBase } from "../../base/api-base";

export function useGerarRelatorioRMV() {
  const { invocarApi, carregando, ...outrasPropriedades } = useApiBase();

  const gerarRelatorioRMV = useCallback(
    (filtros: RelatorioMensalVendaModel) => {
      return invocarApi({
        url: `Relatorio/relatorio-rmv`,
        method: "POST",
        enviarTokenUsuario: true,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(filtros),
        baseURL: VariaveisAmbiente.apiUrl,
        typeDomain: ETypeDomain.TouchPharma,
        apiVersion: 'v1'
      });
    },
    [invocarApi]
  );
  return {
    ...outrasPropriedades,
    carregando,
    gerarRelatorioRMV,
  };

}